"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconHumidity = function IconHumidity(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M14 45.824v-15.41l16-16 7.293 7.293 1.414-1.414L30 11.586 9.5 32.085 7.415 30 30 7.415l14.293 14.292 1.414-1.414L30 4.586 4.586 30 9.5 34.914l2.5-2.5v12.375q.972.563 2 1.035M37.176 27.14l1.076 1.346a29 29 0 0 1 1.966 2.788l.2.31c1.294 2.04 1.962 3.596 1.96 4.705a5.15 5.15 0 1 1-10.277.702 7 7 0 0 1-.002-.625l-.006-.073c-.05-1.18.586-2.684 1.888-4.737l.19-.297c.617-.913 1.4-2.014 1.798-2.546l.16-.215zm.285 3.612-.256-.346-.488.69c-.295.419-.614.877-.878 1.267-1.244 1.918-1.81 3.245-1.744 3.896l.004.152a5 5 0 0 0-.002.458 3.15 3.15 0 0 0 3.363 2.922c1.736-.121 3.044-1.627 2.92-3.432l-.005-.114c-.058-.755-.67-2.09-1.844-3.898l-.345-.54a28 28 0 0 0-.725-1.055M30 32.73a2.22 2.22 0 0 0 1.29 2.06c-.15.51-.22 1.039-.21 1.57v.27a4 4 0 0 1-2.88-3.9c0-.91.61-2.32 1.79-4.17.87-1.35 1.76-2.48 1.76-2.48l.25-.32.24.32q.934 1.201 1.76 2.48l.35.62c-.32.45-.69.98-1.06 1.56l-.09.14c-.2-.38-.45-.81-.78-1.33-.15-.24-.31-.48-.46-.7-.15.22-.31.46-.46.7-1.5 2.28-1.5 3.09-1.5 3.18M19 11v1h-8v-1zm-3 3.5h-2v4.67l-2 2V13h6v2.17l-2 2z",
    clipRule: "evenodd"
  })));
};

export { IconHumidity, IconHumidity as default };
